import { render, staticRenderFns } from "./Provider.vue?vue&type=template&id=2edc9db9&"
import script from "./Provider.vue?vue&type=script&lang=ts&"
export * from "./Provider.vue?vue&type=script&lang=ts&"
import style0 from "./Provider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports